import { Component, OnDestroy, OnInit } from '@angular/core';
import { BillingGridConfiguration, BillingRequestModel } from './venue-billing.model';
import { BillingService, CalcBillingService } from './venue-billing.service';
import { MONTHS, YEARS } from '../../shared/consts/date.const';
import { StatisticsGroupModel } from 'app/shared/objects/statistics-group.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-venue-billing',
  templateUrl: './venue-billing.component.html',
  styleUrls: ['./venue-billing.component.less'],
  providers: [BillingService, CalcBillingService,],
})
export class VenueBillingComponent implements OnInit, OnDestroy {
  billingGridConfiguration: BillingGridConfiguration;
  billingGridRequest: BillingRequestModel;

  months = MONTHS;
  years = YEARS;

  selectedYear: any;
  selectedMonth: any;
  initYear: any;
  calcButtonShow: boolean;
  statisticsGroupModel: StatisticsGroupModel[];
  private billingSubscription: Subscription;

  constructor(private billingService: BillingService, private calcBillingService: CalcBillingService) {
  }

  ngOnInit() {
    this.billingGridConfiguration = new BillingGridConfiguration();
    this.billingGridConfiguration.service = this.billingService;
    this.billingGridRequest = new BillingRequestModel();

    const today = new Date();

    this.selectedYear = this.years.indexOf(this.years.find(x => x.year === today.getFullYear()));
    this.initYear = today.getFullYear();
    this.selectedMonth = today.getMonth();

    if (this.selectedMonth === 0) {
      this.selectedMonth = 12;
      this.selectedYear--;
      this.initYear--;
    }

    this.calcButtonShow = false;
    this.billingGridRequest.month = this.selectedMonth;
    this.billingGridRequest.year = this.initYear;


    this.calcButtonShowCompute();
    this.loadBillingData();
  }

  calcButtonShowCompute() {
    const today = new Date();
    let lastAvailableMonth = today.getMonth();
    let lastAvailableYear = this.years.indexOf(this.years.find(x => x.year === today.getFullYear()));

    if (lastAvailableMonth === 0) {
      lastAvailableMonth = 12;
      lastAvailableYear--;
    }

    this.calcButtonShow = (((this.selectedMonth <= lastAvailableMonth) && (this.selectedYear === lastAvailableYear))
      || (this.selectedYear < lastAvailableYear));

  }

  previousMonth() {
    if (this.selectedMonth === 1) {
      this.selectedMonth = 12;
      this.selectedYear--;
    } else {
      this.selectedMonth--;
    }
    this.refreshGrid();
  }

  nextMonth() {
    if (this.selectedMonth === 12) {
      this.selectedMonth = 1;
      this.selectedYear++;
    } else {
      this.selectedMonth++;
    }
    this.refreshGrid();
  }

  previousYear() {
    if (this.selectedYear === 0) {
      this.selectedYear = this.years.length - 1;
    } else {
      this.selectedYear--;
    }
    this.refreshGrid();
  }

  nextYear() {
    if (this.years.length === this.selectedYear + 1) {
      this.selectedYear = 0;
    } else {
      this.selectedYear++;
    }
    this.refreshGrid();
  }



  exportData() {
    this.billingGridConfiguration.dataGrid.instance.exportToExcel(false);
    this.refreshGrid();

  }

  calcData() {
    this.calcBillingService.getInvoices(this.billingGridRequest).subscribe(() => {
      this.refreshGrid();
    });
  }

  private refreshGrid() {
    this.billingGridRequest.month = this.selectedMonth;
    this.billingGridRequest.year = this.years[this.selectedYear].year;

    this.billingGridConfiguration.refreshGrid();

    this.calcButtonShowCompute();
    this.loadBillingData();
  }

  loadBillingData() {

    this.billingSubscription = this.billingService.getBillingData(this.billingGridRequest).subscribe(
      data => {
        this.statisticsGroupModel = data;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.billingSubscription) {
      this.billingSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-billing/venue-billing.component.ts